import { GraphUtils } from '@helpers/graph.helper';
import { Sensor } from '../sensor/sensor';
import { Router } from '@angular/router';
import { UtilsHelper } from '@helpers/utils.helper';

export class HumidityAttribute extends Sensor {
  public humidityChart: any;
  private humiditySensor: any[];
  public iconsToDisplay: { icon: string, type: number }[] = [];

  constructor(router: Router, url: string, alertsActive: boolean) {
    super(router, url, alertsActive);
    this.humidityChart = null;
    this.humiditySensor = [];
  }

  private ensureArraySize(arr: any[], position: number): void {
    while (arr.length <= position) {
      arr.push([]);
    }
  }

  public prepareData(): void {
    const iconMap = new Map<string, { icon: string, type: number }>();
    for (const element of this.data) {
      const date = new Date(element.date);
      const timestamp = GraphUtils.getDateUtc(date);
      const position = element.position;
      const sensorInfo = UtilsHelper.nameSensor(element.type);
      const icon = sensorInfo.icon;
      if (!iconMap.has(icon)) {
        iconMap.set(icon, {
          icon,
          type: element.type
        });
      }

      this.ensureArraySize(this.humiditySensor, position);
      this.humiditySensor[position].push([timestamp, element.humidity]);
    }
    this.iconsToDisplay = Array.from(iconMap.values());
  }

  public setCharts(): void {
    const filteredHumidity = this.humiditySensor.filter(series => series.length > 0);

    const positionNodeHumidity = this.humiditySensor
      .map((item, index) => (item.length > 0 ? index + 1 : -1))
      .filter(index => index !== -1);

    this.humidityChart = this.getConfigChar(
      'humidity',
      this.getChartSeriesNewNode('Sensor', filteredHumidity, positionNodeHumidity),
      this.getRanges('humidity'),
      this.getLimits('humidity')
    );
  }

  public hasHumiditySensor(pos: number): boolean {
    const index = pos - 1;
    return (
      index >= 0 &&
      index < this.humiditySensor.length &&
      this.humiditySensor[index].length > 0
    );
  }

  public getHumiditySensor(pos: number): any {
    const index = pos - 1;
    if (index >= 0 && index < this.humiditySensor.length) {
      const sensorData = this.humiditySensor[index];
      if (sensorData.length > 0) {
        return sensorData[sensorData.length - 1][1] ?? null;
      }
    }
    return null;
  }

  public static getVariables(): any[] {
    return [
      { title: 'Humedad', value: 'humidity' }
    ];
  }
}
